import { fetchPostJson } from "@/api/generic_fetch"
import airbrakeClient from "./airbrake"
import { IS_PRODUCTION, IS_PRODUCTION_OR_STAGING } from "./environment"

type Severity = (typeof SEVERITY)[keyof typeof SEVERITY]

interface EventData {
  message: string
  params?: object
  referenceNumber?: string
  severity: Severity
  time: string
}

const SEVERITY = Object.freeze({
  ERROR: "ERROR",
  INFO: "INFO",
  WARNING: "WARNING"
} as const)

const logEvent = async (
  identifier: string,
  logUrl: string,
  eventData: Omit<EventData, "time">
): Promise<void> => {
  const { message, params, referenceNumber, severity } = eventData
  const payload = {
    message,
    params: {
      user_agent: navigator.userAgent,
      ...params
    },
    referenceNumber,
    severity,
    time: new Date().toISOString()
  }

  if (!IS_PRODUCTION) {
    console.log(`[${identifier}]`, payload) // eslint-disable-line no-console
  }

  if (IS_PRODUCTION_OR_STAGING) {
    try {
      await fetchPostJson(logUrl, payload)
    } catch (_) {
      // Ignore network errors
    }

    if (severity === SEVERITY.ERROR) {
      void airbrakeClient.notify({ error: message, params })
    }
  }
}

const logApexxEvent = async (
  severity: Severity,
  message: string,
  referenceNumber?: string,
  params?: object
): Promise<void> => {
  await logEvent("APEXX", "/logs/apexx", {
    severity,
    message,
    referenceNumber,
    params
  })
}

const logApplePayEvent = async (
  severity: Severity,
  message: string,
  referenceNumber?: string,
  params?: object
): Promise<void> => {
  await logEvent("Apple Pay", "/logs/apple_pay", {
    severity,
    message,
    referenceNumber,
    params
  })
}

const logGooglePayEvent = async (
  severity: Severity,
  message: string,
  referenceNumber?: string,
  params?: object
): Promise<void> => {
  await logEvent("Google Pay", "/logs/google_pay", {
    severity,
    message,
    referenceNumber,
    params
  })
}

export { type Severity, SEVERITY, logApexxEvent, logApplePayEvent, logGooglePayEvent }
